import { SafeAreaView } from "react-native-safe-area-context"
import { TrueSheet, useTrueSheet } from "@lodev09/react-native-true-sheet"

import { Header, List, Text, Image, MCIcon } from "@src/components"
import { useNumCols } from "@src/hooks"
import { ar } from "@src/i18n"
import { ENV, sharedStyles, trpc } from "@src/utils"
import { ActivityIndicator, Pressable, View } from "react-native"
import { Href, Link, router } from "expo-router"

const REF = {
  product: "products",
}

export default function Images() {
  const sheet = useTrueSheet()
  const images = trpc.images.listBucketImages.useInfiniteQuery({}, { getNextPageParam: (lastPage) => lastPage.cursor })
  const numCols = Math.min(4, Math.max(2, useNumCols(250, { maxWidth: 1400 })))

  return (
    <>
      <Header title={ar.images} />

      <List
        contentContainerStyle={sharedStyles.contentContainer}
        data={images.data?.pages?.flatMap((page) => page.images) ?? []}
        numColumns={numCols}
        key={`storage-products-${numCols}`}
        keyExtractor={(item) => item.key}
        onEndReached={() => (images.hasNextPage ? images.fetchNextPage() : undefined)}
        onRefresh={images.refetch}
        onEndReachedThreshold={0.8}
        ListEmptyComponent={images.isLoading ? <ActivityIndicator className="py-8" /> : <Text className="text-gray-500 text-center py-8">{ar.noImages}</Text>}
        renderItem={({ item }) => {
          return (
            <View className="flex-1 aspect-square m-1 border border-gray-100 bg-white">
              <Image
                contentFit="contain"
                cachePolicy="memory"
                source={`${ENV.R2_URL}/${item.key}`}
                className="w-full aspect-square"
                recyclingKey={item.key}
                transition={250}
                loading="lazy"
              />
              <View className="flex-row items-center gap-2 absolute top-0 left-0">
                {item.references?.map((ref) => (
                  <Pressable
                    key={`${ref.entity}/${ref.entityId}`}
                    onPress={() => {
                      if (ref.entity === "product") {
                        router.push(`/dashboard/products/${ref.entityId}`)
                      }
                    }}
                  >
                    <Text>{ref.entity}</Text>
                  </Pressable>
                ))}
              </View>
              {/* <Pressable className="absolute top-1 left-1 p-2 bg-gray-100 rounded" onPress={() => sheet.present("sheet")}>
                <MCIcon name="more" size={24} />
              </Pressable> */}
            </View>
          )
        }}
        ListFooterComponent={<SafeAreaView edges={["bottom"]} />}
      />

      <TrueSheet name="sheet" maxContentHeight={200}>
        <View className="h-[200] bg-red-300" />
      </TrueSheet>
    </>
  )
}
